import React from 'react';

export default class RowComponent extends React.Component {
    render() {
        return (
            <tbody>
                <tr>
                    <td onClick={() => this.props.openDetails(this.props.doctor)}>{this.props.doctor.name}</td>
                    <td onClick={() => this.props.openDetails(this.props.doctor)}>{this.props.doctor.lastname}</td>
                    <td onClick={() => this.props.openDetails(this.props.doctor)}>{this.props.doctor.status}</td>
                    <td>
                        <button onClick={() => this.props.edit("edit", this.props.doctor)} 
                            className="edit-button">
                            <i className="fas fa-pencil-alt"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/doctors/components/row/index.js